import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "footer",
  templateUrl: "footer.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, TranslatePipe],
})
export class FooterComponent {
  protected activeItem = input<string>();
  protected year = new Date().getFullYear();
}
